import { render, staticRenderFns } from "./NewsPost.vue?vue&type=template&id=4c31858b&"
import script from "./NewsPost.vue?vue&type=script&lang=ts&"
export * from "./NewsPost.vue?vue&type=script&lang=ts&"
import style0 from "./NewsPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports